import { comment_api } from '@axo/shared/data-access/api';
import { useAPI } from '@axo/shared/data-access/provider';
import type { comment } from '@axo/shared/data-access/types';
import { useQuery } from 'react-query';
import { communicationKeys } from '../../cache-keys/communicationKeys';

/**
 * Customer-authed read of user comments for a loan application
 * (`GET /comment/by/user`, MV-2935). Fetch-on-load, no polling — a
 * re-booking reflects on the next load/refetch. Returns the raw array;
 * selecting the latest booking is the consumer's job.
 */
export function useUserComments(applicationId?: string) {
  const api = useAPI();
  return useQuery<comment.UserComment[], Error>({
    queryKey: communicationKeys.userComments({ applicationID: applicationId }),
    queryFn: () => comment_api.getUserComments(api)(applicationId ?? ''),
    enabled: api.token.length > 0 && Boolean(applicationId),
  });
}
